export default __webpack_public_path__ + "static/media/intelStill.50b7d097.jpg";